export default __webpack_public_path__ + "static/media/section2.87764884.jpg";